import html from "./SurveyTemplateContainer.html"
import "../PlatformCompatibilityService.js"
import "../SurveyManager.js"
import "./SurveyModal.js"

var module = angular.module("ResearchKitApplicationModule");

module.component('surveyTemplateContainer', {
	template: html,
	bindings: {
		previewModel: '<',
		template: '<',
		firstStepIndex: '<?',
		mode: '<?'
	},
	controller: 'surveyTemplateContainerController',
	controllerAs: 'vm'
});

module.controller("surveyTemplateContainerController", ["$scope", "$q", "platformCompatibilityService", "surveyManagerFactory",
	function ($scope, $q, platformCompatibilityService, surveyManagerFactory) {
		var vm = this;

		function surveyFinished(reason) {
			var result = vm.surveyManager.getResult();
			if (reason === "Completed") {
				$scope.$emit("surveyFinished", reason, result);
			} else {
				$scope.$emit("surveyFinished", reason);
			}
			vm.surveyManager = null;
			vm.platforms = null;
		}

		function saveResults() {
			var emptyPromise = $q.defer();
			emptyPromise.resolve();
			return emptyPromise.promise;
		}

		this.$onChanges = function (changesObj) {
			if ((changesObj.previewModel && changesObj.previewModel.currentValue) || (changesObj.template && changesObj.template.currentValue)) {
				const definition = changesObj.previewModel?.currentValue?.SurveyDefinition || changesObj.template?.currentValue;
				vm.platforms = platformCompatibilityService.getPlatforms(definition);
				if (vm.platforms.indexOf("Web") === -1) return;

				vm.surveyManager = surveyManagerFactory.createSurveyManager({
					template: definition,
					taskID: null,
					participantStateAudit: null,
					finishedCallback: surveyFinished,
					saveResultsCallback: saveResults,
					expressionInputs: changesObj.previewModel?.currentValue?.ExpressionInputs
				}, {
					mode: vm.mode ?? "Survey",
					isCoordinatorEntered: false
				});

				vm.surveyManager.startSurvey(vm.firstStepIndex);
			}
		};
	}]);
